/**
 * Drop selected filter items whose parent is no longer selected.
 *
 * Child groups (Framing, Humanism, ... under Characters) carry `parent_ids` on
 * their items; the backend rejects a set where a child's parent is absent
 * ("Bad filter input, parent item not found"). file-edit prunes these through
 * FilterItemObject's watcher, which only exists while the editor is mounted.
 * The GUP uploads bar swaps the asset type on a folded row, so it prunes here.
 *
 * Pure, schema-driven, runnable under bare node (see the .check.mjs).
 * Iterates to a fixed point: a pruned child can itself be a parent.
 */
export function pruneOrphanFilters(selectFilter, schema) {
    const parentsOf = {};
    const walk = (groups) => (groups || []).forEach((g) => {
        if (g.children_filter == null) {
            (g.filter_items || []).forEach((it) => {
                if (Array.isArray(it.parent_ids) && it.parent_ids.length > 0) parentsOf[it.id] = it.parent_ids;
            });
        }
        else walk(g.children_filter);
    });
    walk(schema);

    let kept = [...(selectFilter || [])];
    for (;;) {
        const set = new Set(kept);
        const next = kept.filter((id) => {
            const parents = parentsOf[id];
            return parents == null || parents.some((p) => set.has(p));
        });
        if (next.length === kept.length) return next;
        kept = next;
    }
}
